// Zustand Store for VinciKit Configuration State
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useConfigStore = create(
  persist(
    (set, get) => ({
      // Session
      sessionId: null,
      
      // User input
      goal: '',
      
      // Interview data
      interview: {
        expertise: '',
        currentTools: [],
        budget: '',
        timeline: '',
        additionalContext: '',
      },
      
      // Chat history
      messages: [],
      
      // Recommended stack
      stack: null,
      
      // UI state
      currentStep: 'goal', // 'goal' | 'interview' | 'stack' | 'waitlist'
      isLoading: false,
      error: null,
      
      // Actions
      setGoal: (goal) => set({ goal }),
      
      setSessionId: (sessionId) => set({ sessionId }),
      
      updateInterview: (data) => set((state) => ({
        interview: { ...state.interview, ...data }
      })),
      
      addMessage: (message) => set((state) => ({
        messages: [...state.messages, message]
      })),
      
      clearMessages: () => set({ messages: [] }),
      
      setStack: (stack) => set({ stack }),
      
      setCurrentStep: (step) => set({ currentStep: step }),
      
      setLoading: (isLoading) => set({ isLoading }),
      
      setError: (error) => set({ error }),
      
      // Reset everything
      reset: () => set({
        sessionId: null,
        goal: '',
        interview: {
          expertise: '',
          currentTools: [],
          budget: '',
          timeline: '',
          additionalContext: '',
        },
        messages: [],
        stack: null,
        currentStep: 'goal',
        isLoading: false,
        error: null,
      }),
      
      // Get full configuration for API
      getConfiguration: () => {
        const state = get();
        return {
          sessionId: state.sessionId,
          goal: state.goal,
          ...state.interview,
        };
      },
    }),
    {
      name: 'vincikit-config',
      partialize: (state) => ({
        sessionId: state.sessionId,
        goal: state.goal,
        interview: state.interview,
        messages: state.messages,
        stack: state.stack,
        currentStep: state.currentStep,
      }),
    }
  )
);

export default useConfigStore;
